import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { hasAdminAccess } from "@/lib/admin-access";
import { AdminShell } from "@/components/admin/AdminShell";
import { MockSchedulingTable } from "@/components/admin/MockSchedulingTable";
import { MockBookingsTracker } from "@/components/admin/MockBookingsTracker";
import { useIsTesterAccount } from "@/lib/tester";


export const Route = createFileRoute("/admin/mock-scheduling")({
  head: () => ({
    meta: [
      { title: "Mock Scheduling & DS Reviews - WeLivdIt Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminMockSchedulingPage,
});

function AdminMockSchedulingPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const isTester = useIsTesterAccount();

  useEffect(() => {
    (async () => {
      const { data: sess } = await supabase.auth.getSession();
      if (!sess.session) {
        navigate({ to: "/auth", search: { redirect: "/admin/mock-scheduling" } });
        return;
      }
      setAuthorized(await hasAdminAccess(sess.session));
      setLoading(false);
    })();
  }, [navigate]);

  if (loading)
    return (
      <div className="min-h-[60vh] grid place-items-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (!authorized)
    return (
      <div className="min-h-[60vh] grid place-items-center px-5">
        <p className="text-muted-foreground">Not authorized.</p>
      </div>
    );

  return (
    <AdminShell
      title="Mock Scheduling & DS-160 Reviews"
      description="Enrolled Full Support and Refusal Support students, sorted by the closest biometrics date."
    >
      <div className="mt-2 space-y-8">
        {isTester && <MockBookingsTracker />}
        <MockSchedulingTable />
      </div>

    </AdminShell>
  );
}
